// 0 Кто Вы?
// 1 Я руководитель действующей службы легкового или грузового такси
// 2 Хочу открыть новую службу легкового или грузового такси
// 3 Хочу устроиться работать водителем
// 4 Хочу устроиться работать диспетчером

const REG_SELECT_ID = 'reg-select'
const REG_FORM_CONTAINER = 'reg-form-container'
const REG_FORM_WHO_YOU_ARE_ERROR_TEXT = 'who-you-are-error-text'
const REGISTRATION_FORM = 'registration-form'
const REGISTRATION_BTN = 'registration-btn'
const LINK = '/cabinet/ajax/register.php'

const registrationBtn = document.getElementById(REGISTRATION_BTN)
const regSelectElement = document.getElementById(REG_SELECT_ID)
// заполним форму промокодом если он есть
fillPromo()
// нажатие на кнопку регистрации
if (registrationBtn) {
  registrationBtn.onclick = function (event) {
    this.disabled = true
    document.getElementById('loader').style.display = 'block'
    event.preventDefault()
    // #err-fio
    // у middle_name не должно быть ошибки, его можно не заполнять

    $(
      '#err-email, #err-password, #err-phone, #err-rnd, #err-oferta, #err-politics, #err-some, #err-who-you-are, #err-fio'
    ).html('')
    $(
      '#email, #password, #password2, #err-fio, #phone, #rnd, #reg-select'
    ).removeClass('error')
    registration()
  }
} else {
  console.log('registrationBtn not found!')
}
function initWhoYouAre(regSelectVal) {
  if (Number(regSelectVal) === 3 || Number(regSelectVal) === 4) {
    hideRgFormContainer()
  } else {
    showRgFormContainer()
  }
  $('#err-who-you-are').html('')
  $('#reg-select').removeClass('error')
}

function hideRgFormContainer() {
  const container = document.getElementById(REG_FORM_CONTAINER)
  const error = document.getElementById(REG_FORM_WHO_YOU_ARE_ERROR_TEXT)
  container.classList.add('hidden')
  error.classList.remove('hidden')
}
function showRgFormContainer() {
  const container = document.getElementById(REG_FORM_CONTAINER)
  const error = document.getElementById(REG_FORM_WHO_YOU_ARE_ERROR_TEXT)
  container.classList.remove('hidden')
  error.classList.add('hidden')
}

regSelectElement.addEventListener('change', function () {
  const selectedValue = regSelectElement.value
  initWhoYouAre(selectedValue)
})

// регистрация
function registration() {
  const validateResult = validateRegistration()
  if (!validateResult) {
    registrationBtn.disabled = false
    document.getElementById('loader').style.display = 'none'
    return
  }

  const email_input = document.getElementById('email')
  const fio = document.getElementById('fio')
  const phone = document.getElementById('phone')
  const password = document.getElementById('password')
  const password2 = document.getElementById('password2')
  const rnd = document.getElementById('rnd')
  const oferta = document.getElementById('oferta')
  const politics = document.getElementById('politics')

  const promo = document.getElementById('promo')

  const lang = document.getElementById('lang__js').getAttribute('lang')
  // #last_name, #first_name, #middle_name

  let ofertaCheck = 0
  let politicsCheck = 0
  const valEmail = email.value
  const whoYouAre = regSelectElement.value
  if (oferta.checked) {
    ofertaCheck = 1
  }
  if (politics.checked) {
    politicsCheck = 1
  }

  // Если есть промо-код, то заполним его без учета что клиент ввел сам
  let promoValue = ''
  const cookiePromo = getCookie('promo')
  if (cookiePromo) {
    promoValue = cookiePromo
  } else {
    promoValue = promo.value
    setPromoCookie()
  }

  // console.log("promomo", promoValue);
  // TODO убрать return перед заливкой на прод

  // return
  $.ajax({
    type: 'POST',
    url: LINK,
    dataType: 'json',
    data: {
      fio: fio.value,
      email: valEmail,
      phone: phone.value,
      password: password.value,
      password2: password2.value,
      rnd: rnd.value,
      oferta: ofertaCheck,
      politics: politicsCheck,
      lang: lang,
      whoYouAre: whoYouAre,
      referral_code: promoValue,
    },

    error: function (jqXHR, textStatus, errorThrown) {
      registrationBtn.disabled = false
      document.getElementById('loader').style.display = 'none'
    },
    success: function (data) {
      if (data['result'] == 0) {
        registrationBtn.disabled = false
        document.getElementById('loader').style.display = 'none'
        if (data['already_auth_err'] === 1) {
        }
        if (data['err_email']) {
          email_input.classList.add('error')
          document.getElementById('err-email').innerHTML = data['err_email']
          document.getElementById('err-email').style.display = 'block'
        }
        if (data['err_psw']) {
          password.classList.add('error')
          password2.classList.add('error')
          document.getElementById('err-password').innerHTML = data['err_psw']
          document.getElementById('err-password').style.display = 'block'
        }
        if (data['err_fio']) {
          fio.classList.add('error')
          document.getElementById('err-fio').innerHTML = data['err_fio']
          document.getElementById('err-fio').style.display = 'block'
        }
        if (data['err_phone']) {
          phone.classList.add('error')
          document.getElementById('err-phone').innerHTML = data['err_phone']
          document.getElementById('err-phone').style.display = 'block'
        }
        if (data['err_rnd']) {
          rnd.classList.add('error')
          document.getElementById('err-rnd').innerHTML = data['err_rnd']
          document.getElementById('err-rnd').style.display = 'block'
        }
        if (data['err_politics']) {
          document.getElementById('err-politics').innerHTML =
            data['err_politics']
          document.getElementById('err-politics').style.display = 'block'
        }
        if (data['err_oferta']) {
          document.getElementById('err-oferta').innerHTML = data['err_oferta']
          document.getElementById('err-oferta').style.display = 'block'
        }
        if (data['some_err']) {
          document.getElementById('err-some').innerHTML = data['some_err']
          document.getElementById('err-some').style.display = 'block'
        }
      }
      // console.log('success1', data)
      if (data['result'] == 1) {
        localStorage.setItem('mail', valEmail)
        // console.log('success2', data)
        ym(29322725, 'reachGoal', 'registration')
        redirectToRegistrationThanks()
      }
    },
  })
}

function validateRegistration() {
  const whoYouAreValue = regSelectElement.value
  if (Number(whoYouAreValue) === 0) {
    regSelectElement.classList.add('error')
    document.getElementById('err-who-you-are').innerHTML = 'Выберете кто Вы'
    document.getElementById('err-who-you-are').style.display = 'block'
    return false
  } else if (Number(whoYouAreValue) === 3 || Number(whoYouAreValue) === 4) {
    regSelectElement.classList.add('error')
    document.getElementById('err-who-you-are').innerHTML =
      'У нас нельзя устроиться на работу водителем или диспетчером!'
    document.getElementById('err-who-you-are').style.display = 'block'
    return false
  } else {
    return true
  }
}

function redirectToRegistrationThanks() {
  const currentLink = window.location.href
  const parts = currentLink.split('/')
  if (parts.length <= 5) {
    // console.log('111', parts)
    location = '/registration_thanks'
  } else {
    location = '/' + parts[3] + '/registration_thanks'
    // console.log('222', parts)
  }
}

function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1') + '=([^;]*)'
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

// посмотрим есть ли в куках промо-код и если есть, то заполним его
function fillPromo() {
  const promo = getCookie('promo')
  if (promo) {
    const promoInput = document.getElementById('promo')
    if (promoInput) {
      promoInput.disabled = true // Дизейблит инпут
      promoInput.value = promo
    }
  }
}

// Функция для установки куки
function setCookie(name, value, days) {
  let expires = ''
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}
// Функция для установки промо-кода в куки
function setPromoCookie() {
  const promoInput = document.getElementById('promo')
  const promoCode = promoInput.value

  if (promoCode) {
    setCookie('promo', promoCode, 60) // Устанавливаем куки на 60 дней
    console.log('Promo code set in cookie:', promoCode)
  }
}
